// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badesul-pix-modal canvas {
  width: 40% !important;
  height: auto !important;
}
.badesul-pix-modal .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
}
.badesul-pix-modal .copy-clipboard-button {
  display: flex;
  flex-direction: row-reverse;
  color: black;
}
.badesul-pix-modal .copy-clipboard-button span {
  font-weight: 300 !important;
}
`, "",{"version":3,"sources":["webpack://./src/screens/HomeScreen/components/BadesulPixModal/styles.less"],"names":[],"mappings":"AAAA;EAEI,qBAAA;EACA,uBAAA;AAAJ;AAHA;EAMI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAAJ;AAVA;EAaI,aAAA;EACA,2BAAA;EACA,YAAA;AAAJ;AAfA;EAkBM,2BAAA;AAAN","sourcesContent":[".badesul-pix-modal {\n  canvas {\n    width: 40% !important;\n    height: auto !important;\n  }\n  .content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n    text-align: center;\n  }\n  .copy-clipboard-button {\n    display: flex;\n    flex-direction: row-reverse;\n    color: black;\n\n    span {\n      font-weight: 300 !important;\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
